module.exports = __webpack_public_path__ + "img/Document.38a124f5.svg";